export const min_width = '(min-width: 760px)'
export const max_width = '(max-width: 759px)'


export const loginPage = '/Login'
export const createAccountPage = '/CreateAccount'
export const selectManagerPage = '/SelectManager'
export const selectRegionPage = '/SelectRegion'
export const realtorsPage = '/Realtors'
export const addPointsPage = '/AddPoints'
export const onHoldPointsPage = '/OnHoldPoints'
export const realtorPage = '/Realtor'
export const pointDetailPage = '/PointDetail'
export const pointsPage = '/Points'
export const notificationsPage = '/Notifications'
export const notificationPage = '/Notification'
export const informationPage = '/Information'
export const legalDisclaimerPage = '/LegalDisclaimer'
export const registrationPage = '/Registration'
export const eventsPage = '/Events'
export const profilePage = '/Profile'
export const registrationPreviewPage = '/RegistrationPreview'
export const emailVerificationPage = '/EmailVerification'
export const myPointsPage = '/MyPoints'
export const mySubmittedPointsPage = '/MySubmittedPoints'
export const communitiesPage = '/Communities'
export const regionsPage = '/Regions'
export const rewardsPage = '/Rewards'
export const viewClientRegistrationsPage = '/ViewClientRegistrations'
export const viewOnHoldPointsPage = '/ViewOnHoldPoints'
export const manageUsersPage = '/ManageUsers'
export const adminSettingsPage = '/AdminSettings'
export const composeNotificationPage = '/ComposeNotification'
export const CreateCompanyAccountPage = '/CreateCompanyAccount'
export const registrationRulesPage = '/RegistrationRules'
export const billingPage = '/Billing'
export const autoNotificationsPage = '/AutoNotifications'
export const bonusLevelSettingsPage = '/BonusLevelSettings'
export const bonusLevelsPage = '/BonusLevels'
export const pointSettingsPage = '/PointSettings'
export const addEventsPage = '/AddEvents'


export const toolTipTimeButton = 300
export const toolTipTimeTable = 300






// WEBPACK FOOTER //
// ./src/components/Root/Const.js